<template>
  <v-app>
   
    <v-toolbar
      app
      class="blue-grey lighten-1"
      dark
    >

    <v-toolbar-title >
        <strong><router-link to="/" tag="span" style="cursor: Pointer">
          <v-icon>account_balance</v-icon> ThimelEDU
          </router-link></strong>
      </v-toolbar-title>
     <v-spacer></v-spacer>

    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
   
    <v-footer :fixed="fixed" app>
      <span>&copy;NILEgamelab 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      fixed: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire"
        },
        {
          icon: "book",
          title: "Book"
        }
      ],
      miniVariant: false,
    };
  },
  computed:{
    user(){
      return this.$store.getters.user;
    }
  },
  name: "App"
};
</script>



// WEBPACK FOOTER //
// src/App.vue